import { API_ROUTE_TRADE_IN_ASSET_ORDER } from '@/resources/api-routes'
import { get } from '@/util/auth'

import type { Status } from './getTradeInOrders'

type Meta = {
  items: OrderOriginal[]
  pageNumber: number
  totalPages: number
  totalCount: number
  hasPreviousPage: boolean
  hasNextPage: boolean
}

type OrderOriginal = {
  id: string
  createdOn: '2023-07-05T12:00:00Z'
  createdBy: 'string'
  status: string
  statusCode: Status
}

const IS_NEW_BACKEND_API = true

export const getTradeInAssetOrder = async (assetGuid: string) => {
  const order = await get<Meta>(
    API_ROUTE_TRADE_IN_ASSET_ORDER.replace(':assetId', String(assetGuid)),
    IS_NEW_BACKEND_API
  )

  return order.items
}
